import { useRecordContext } from "react-admin";
import PreviewExamProtocolButton from "./PreviewExamProtocolButton";
import ImportExamResultsButton from "./ImportExamResultsButton";
import UpdateExamResultsButton from "./UpdateExamResultsButton";
import ExportExamResultsButton from "./ExportExamResultsButton";
import ApproveExamResultsButton from "./ApproveExamResultsButton";
import PreviewExamResultsProtocolButton from "./PreviewExamResultProtocolButton";

const CampaignExamButtons = ({ isFinished }) => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  const examPassed = record.examPassed || record.examDays?.every(day => day.examPassed);

  if (!examPassed) {
    return (
      <>
        <PreviewExamProtocolButton exam={record} />
        <PreviewExamResultsProtocolButton exam={record} />
      </>
    );
  }

  return (
    <>
      <ImportExamResultsButton
        exam={record}
        isFinished={isFinished}
      />
      <UpdateExamResultsButton
        exam={record}
        isFinished={isFinished}
      />
      <ExportExamResultsButton exam={record} />
      <ApproveExamResultsButton
        exam={record}
        isFinished={isFinished}
      />
      <PreviewExamResultsProtocolButton exam={record} />
    </>
  );
};

export default CampaignExamButtons;
